var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("Groups", {
        ref: "groups",
        attrs: {
          feature: "survey",
          groups: _vm.groups,
          groupSelector: "group",
          groupCopyFunction: g => _vm.GroupSurveyExtension.fromJS(g),
          groupInitFunction: () => _vm.initGroup(),
          groupSaveFunction: g => _vm.saveGroup(g),
          groupDeleteFunction: g => _vm.deleteGroup(g),
          canDeleteGroups: !_vm.advanceRegistration || _vm.canSurveyAdmin,
          showPinnedGroupsOnly: _vm.showPinnedGroupsOnly,
          allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers,
          vgtManager: _vm.vgtManager,
          vgtColumnModifier: c => _vm.vgtColumnModifier(c)
        },
        scopedSlots: _vm._u(
          [
            {
              key: "editModal",
              fn: function({ availableSalutations, allUsers, setRef }) {
                return [
                  _vm._t("editModal", function() {
                    return [
                      _c("GroupsForSurveyEditModal", {
                        ref: setRef,
                        attrs: {
                          groups: _vm.groups,
                          availableSalutations: availableSalutations,
                          allUsers: allUsers,
                          groupSelector: "group",
                          groupCopyFunction: g =>
                            _vm.GroupSurveyExtension.fromJS(g),
                          groupSaveFunction: g => _vm.saveGroup(g),
                          allowNoEmailForExternalUsers:
                            _vm.allowNoEmailForExternalUsers
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "editModalTitle",
                              fn: function() {
                                return [_vm._t("editModalTitle")]
                              },
                              proxy: true
                            },
                            {
                              key: "editModalTabs",
                              fn: function({ group }) {
                                return [
                                  _vm._t("editModalTabs", null, {
                                    group: group
                                  })
                                ]
                              }
                            },
                            {
                              key: "generalAfter",
                              fn: function({ group }) {
                                return [
                                  _vm._t("generalAfter", null, { group: group })
                                ]
                              }
                            },
                            {
                              key: "externalUserSelectModalTabs",
                              fn: function() {
                                return [_vm._t("externalUserSelectModalTabs")]
                              },
                              proxy: true
                            },
                            {
                              key: "userButtonsBefore",
                              fn: function({ groupUser }) {
                                return [
                                  _vm._t("userButtonsBefore", null, {
                                    groupUser: groupUser
                                  })
                                ]
                              }
                            },
                            {
                              key: "externalUserButtonsBefore",
                              fn: function({ groupUserExternal }) {
                                return [
                                  _vm._t("externalUserButtonsBefore", null, {
                                    groupUserExternal: groupUserExternal
                                  })
                                ]
                              }
                            },
                            {
                              key: "selectedExternalUserButtonsBefore",
                              fn: function({ groupUserExternals }) {
                                return [
                                  _vm._t(
                                    "selectedExternalUserButtonsBefore",
                                    null,
                                    { groupUserExternals: groupUserExternals }
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ]
                  })
                ]
              }
            },
            {
              key: "actionsBefore",
              fn: function({ group }) {
                return [
                  _vm._t("actionsBefore", null, { group: group }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-info",
                      on: {
                        click: function($event) {
                          return _vm.$refs.groupResultsModal.open(group)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-poll" })]
                  )
                ]
              }
            },
            {
              key: "actionsAfter",
              fn: function({ group }) {
                return [
                  _vm.showPinnedGroupsOnly
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.onResultCombined(group)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-poll" })]
                      )
                    : _vm._e()
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("GroupResultsModal", { ref: "groupResultsModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }